import { HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface IAuthenticationService {
    tryRefreshingTokens(): Promise<boolean>;
    expireRefreshToken(): void;
    logout(): void;
    isUserAuthenticated(): boolean;
    getUserId(): string;
    getDecodedToken(): any;
    isAdmin(): boolean;
    isAnyLevel(): boolean;
}
